var LoadService = require('services/load-service');
var CourseSettingsService = require('services/course-settings-service');
var EnrollmentDataService = require('services/enrollment-data-service');
var SessionService = require('services/session-service');
var utils = require('lib/utils');
var DefaultContent = require('data/content');

var content;
var LocaleService = function() {
  if (LocaleService.prototype._singleton) {
    return LocaleService.prototype._singleton;
  }

  LocaleService.prototype._singleton = this;

  this.files = {
    _localeContent: './content/locales/{{locale}}.json',
    _langContent: './content/locales/{{lang}}.json'
  };

  this.fallbackNSes = ['course', 'sdk'];
  this.moduleNS = null;
  Object.defineProperty(this, 'localeContent', { get: function() { return content._localeContent; } });
  Object.defineProperty(this, 'langContent', { get: function() { return content._langContent; } });
  Object.defineProperty(this, 'enContent', { get: function() { return content._enContent; } });
  this.initialize = function(options){
    var deferred = $.Deferred();
    var self = this;

    const split = CourseSettingsService.get('split_module');

    this.files = {
      _localeContent: split ? `./modules/${split}/locales/{{locale}}.json` : './content/locales/{{locale}}.json',
      _langContent: split ? `./modules/${split}/locales/{{lang}}.json` : './content/locales/{{lang}}.json',
    };

    if (options.lng && options.lng.indexOf('-') === 2){
      if (!CourseSettingsService.get('supported_languages').includes(options.lng)) {
        if (CourseSettingsService.get('supported_languages').includes(options.lng.substring(0, 2))){
          options.lng = options.lng.substring(0, 2);
        }
      }
    }

    var i18nextOptions = _.defaults({
      fallbackLng: 'en',
      fallbackNS: this.fallbackNSes,
      keySeparator: '.',
      nsSeparator: '<|>',
      detection: {
        order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
        lookupQuerystring: 'setLng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng'
      },
      whitelist: CourseSettingsService.get('supported_languages'),
      interpolationPrefix: '{{',
      interpolationSuffix: '}}',
      customLoad: function(lng, ns, options, loadComplete){
        //we're loading the files ourselves, don't need i18next to do it;
        // can't find another way of turning this off...
        loadComplete(null, null);
      }
    }, options);

    i18next.use(i18nextBrowserLanguageDetector).init(i18nextOptions, function(){
      var i18nextLang = i18next.language;
      if (i18nextLang.indexOf('-') === 2) {
        self.lang = i18nextLang.substring(0, 2);
        self.locale = i18nextLang;
        self.files._localeContent = self.files._localeContent.replace('{{locale}}', self.locale);
      } else {
        self.lang = i18nextLang;
        self.locale = undefined;
        delete self.files._localeContent;
      }
      self.files._langContent = self.files._langContent.replace('{{lang}}', self.lang);

      if (i18nextLang != 'en'){
        self.files._enContent = './content/locales/en.json';
      }

      LoadService.load(self.files).done(function(data){
        content = data;
        _.each(self.fallbackNSes, function(ns){
          self.addResources(ns);
        });
        deferred.resolve();
      });

      if (DefaultContent[self.lang]){
        i18next.addResourceBundle(self.lang, 'sdk', DefaultContent[self.lang]);
      }
      if (DefaultContent[self.locale]){
        i18next.addResourceBundle(self.locale, 'sdk', DefaultContent[self.locale]);
      }
      i18next.addResourceBundle('en', 'sdk', DefaultContent.en);
    });

    return deferred.promise();
  };

  this.addDefaultResources = function(namespace){
    var prefix = EnrollmentDataService.getData('locale:namespace:prefix');
    var prefixedNameSpace = prefix ? `${prefix}|${namespace}` : namespace;
    this.addResources(namespace);
    this.addResources(prefixedNameSpace);
    if (this.moduleNS) {
      i18next.options.fallbackNS = [namespace].concat(this.fallbackNSes).concat(this.moduleNS);
    }
    i18next.setDefaultNamespace(prefixedNameSpace);
  };

  this.setLocaleNamespacePrefix = function(prefix) {
    EnrollmentDataService.saveData('locale:namespace:prefix', prefix);
  };

  this.setModuleResources = function(moduleKey) {
    var ns = moduleKey + '.defaults';
    this.addResources(ns);
    this.moduleNS = ns;
    //overwrite other fallbacks when starting a new module
    i18next.options.fallbackNS = [ns].concat(this.fallbackNSes);
  };

  this.addResources = function(namespace){
    //en should always be present
    if (!i18next.hasResourceBundle('en', namespace)) {
      this.addResource(this.lang, namespace, this.langContent);

      if (this.locale) {
        this.addResource(this.locale, namespace, this.localeContent);
      }

      if (i18next.language != 'en') {
        this.addResource('en', namespace, content._enContent);
      }
    }
  };

  this.currentNamespace = function() {
    return i18next.options.defaultNS;
  };

  this.addResource = function(lang, namespace, content){
    var resource = utils.dotStringToObject(namespace, content);
    i18next.addResourceBundle(lang, namespace, resource);
  };

  this.t = function(key, options){
    var sessionData = SessionService.getAll();
    var model = CourseSettingsService.getModel();
    var courseData = model ? model.toJSON() : {};
    var data = _.extend(sessionData, courseData, options);
    return i18next.t(key, data);
  };

  this.getLanguage = function(){
    return i18next.language;
  };

  this.isRTL = function(){
    switch(i18next.language) {
      case "ar" :
        // Arabic
      case "he" :
        // Hebrew
      case "ur" :
        // Urdu
        return true;
      default :
        return false;
    }
  };
};

module.exports = new LocaleService();
